import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledBox,
  StyledHeader,
  StyledTitle,
  StyledListFormat
} from './style';

const ContentGrouping = ({
  className,
  title,
  titleWithBorder,
  formats,
  children
}) => (
  <StyledBox className={className}>
    <StyledHeader titleWithBorder={titleWithBorder}>
      <StyledTitle className={className}>{title}</StyledTitle>
      {formats && <StyledListFormat formats={formats} />}
    </StyledHeader>
    {children}
  </StyledBox>
);

ContentGrouping.propTypes = {
  className: PropTypes.string,

  /** Titulo del Agrupador */
  title: PropTypes.string,

  /** true: pinta el borde que va justo debajo del titulo */
  titleWithBorder: PropTypes.bool,

  /** Contenido del agrupador */
  children: PropTypes.node,

  /** Formatos que recibe el componente ListFormat */
  formats: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string
    })
  )
};

ContentGrouping.defaultProps = {
  titleWithBorder: true
};

export default ContentGrouping;
